import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Typography, withStyles, Button } from '@material-ui/core'
import moment from 'moment'
import { generateSelectedPartialLabel } from '../../Utils/PartialShiftHelper'
import { updateMobileOfferForm } from '../../../actions/mobileActions'
import { updateLoading, updateSidePanelData } from '../../../actions';
import AvailableTimeOffRequest from '../../Utils/AvailableTimeOffRequest';
import { getAvailableTimeOffRequestForToCover } from '../../Utils/handlers';
import { EmployeeDashboardMobileSidePanelStyles } from '../../../../styles/mobileStyles';
import { RequestTypes } from '../../../../Enums';
import { SliderPartialRequest } from '../../../components/SliderPartialRequest';

class PartialShift extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleChangePartial = (e, val) => {
        const { formData, updateMobileOfferForm, updateSidePanelData } = this.props
        const shift = formData.shifts[0];
        const startDate = moment.utc(shift.startDateTime);

        let newStartDate = moment.utc(startDate).add(val[0], 'm')
        let newEndDate = moment.utc(startDate).add(val[1], 'm')
        if (formData.managerSetting.isConditionalTimeOffRequestAutoApprovalEnabled) {
            updateSidePanelData({ timeOffRequest: null, timeOffRequestError: null });
            const request = {
                shift: formData.shifts[0],
                adminSettingId: formData.managerSetting.adminSettingsId
            };
            if (!(newStartDate.isSame(moment.utc(shift.startDateTime)) && newEndDate.isSame(moment.utc(shift.endDateTime)))) {
                request.isPartial = true;
                request.partialStartDate = newStartDate;
                request.partialEndDate = newEndDate;
            }
            getAvailableTimeOffRequestForToCover.bind(this)(request);
        }
        updateMobileOfferForm({
            ...formData,
            partialDates: {
                startDate: newStartDate,
                endDate: newEndDate,
            }
        })
    }

    render() {
        const { formData, classes, updateSidePanelView, handlePreviousView, sidePanelData, storeData } = this.props;

        const isTimeOffRequestValid = !(formData.managerSetting?.isConditionalTimeOffRequestAutoApprovalEnabled && !sidePanelData?.timeOffRequest?.id);
        const shift = formData.shifts[0];
        const requestType = formData.managerSetting?.type || 0;
        const selectedPartial = generateSelectedPartialLabel(shift, formData.partialDates.startDate, formData.partialDates.endDate, requestType)

        return (
            <div className={classes.viewContainer}>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant={'h5'} className={classes.viewHeader}>Partial Shift (Optional)</Typography>
                    </Grid>
                    <Grid item xs={12} style={{ padding: '0 20px' }}>
                        <SliderPartialRequest
                            shifts={[shift]}
                            storeData={storeData}
                            requestType={formData.managerSetting.type}
                            handleChange={this.handleChangePartial}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ backgroundColor: '#1a518a', color: '#FFF', textAlign: 'center', padding: '10px 0' }}>
                        {selectedPartial}
                    </Grid>
                    <Grid item xs={12}>
                        <AvailableTimeOffRequest
                            timeOffRequest={sidePanelData.timeOffRequest}
                            error={sidePanelData.timeOffRequestError}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.bottomBar}>
                    <Grid item xs={6} style={{ padding: '5px' }}>
                        <Button fullWidth className={classes.secondaryButton} onClick={handlePreviousView}>
                            Back
                        </Button>
                    </Grid>
                    <Grid item xs={6} style={{ padding: '5px' }}>
                        {(formData.managerSetting.type === RequestTypes.toCover || formData.managerSetting.type === RequestTypes.shiftSwap) ? (
                            <Button fullWidth disabled={!isTimeOffRequestValid} className={classes.primaryButton} onClick={() => updateSidePanelView('SendTo')}>
                                Next
                            </Button>
                        ) : (//Open shift
                            <Button fullWidth className={classes.primaryButton} onClick={() => updateSidePanelView('CommentToManager')}>
                                Next
                            </Button>)}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    storeData: state.data,
    formData: state.mobileOfferShiftForm,
    sidePanelData: state.sidePanelData,
    options: state.httpOptions,
});

const mapDispatchToProps = dispatch => ({
    updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
    updateSidePanelData: (payload) => dispatch(updateSidePanelData(payload)),
    updateLoading: payload => dispatch(updateLoading(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EmployeeDashboardMobileSidePanelStyles)(PartialShift));
